export enum Property {
  CAMUNDA = "camunda.bpm.client.deployment-file",
  ORG_ID = "OrganizationId",
  AMDT_NOTICE_PERIOD = "NoticePeriod_amendment",
  SUP_NOTICE_PERIOD = "NoticePeriod_supplement",
  TIMEZONE = "timezone",
}
